import { createDecorator } from '../../instantiation/common/instantiation.js';
const ICanonicalUriService = ( createDecorator('canonicalUriIdentityService'));
export { ICanonicalUriService };
